import React from 'react';

// A faint, repeating bead-motif watermark — used as a subtle texture layer behind content
// (mobile nav menu, reviews section, footer) instead of a flat empty background. Kept as
// one shared inline SVG so the same low-key pattern reads consistently across the site.
const BackgroundPattern = ({ className = '' }) => (
  <svg
    className={`absolute inset-0 w-full h-full pointer-events-none opacity-[0.06] ${className}`}
    aria-hidden="true"
  >
    <defs>
      <pattern id="prestige-bead-pattern" width="40" height="40" patternUnits="userSpaceOnUse">
        <circle cx="6" cy="6" r="3" fill="currentColor" />
        <circle cx="26" cy="18" r="3" fill="currentColor" />
        <circle cx="14" cy="30" r="3" fill="currentColor" />
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#prestige-bead-pattern)" />
  </svg>
);

export default BackgroundPattern;
